module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/user-report-detail/user-report-detail.component.css
// module id = ./src/app/user-report-detail/user-report-detail.component.css
// module chunks = main